import { Injectable } from '@angular/core';
import { isatty } from 'tty';
import { SearchCase } from '../models/caseModel';

import { DashboardUIState } from '../models/dashboardUIState';

@Injectable()
export class UIStateService {
    public dashboardUI: DashboardUIState = new DashboardUIState();
}